// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"2ba4bb13","139":"9f0d6310","179":"2b23bcb2","203":"c20c21a7","282":"e829cc4d","363":"d7f5036a","617":"6cdbbfc5","637":"b74c3932","671":"d44baf50","947":"c470ba6d"}[chunkId] + ".chunk.js";
};